import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { buildingBlocks, IMAGES } from '../data/audit';
export function CreatedBy() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-118" data-mp="2q3aprmuvp6g4">
      <div className="mx-auto w-full max-w-5xl" data-id="element-119" data-mp="2u4nt9qai0xjv">
        <SectionHeading eyebrow="Created by Dr. Karito" title="A practical approach to complex case review" data-id="element-120" data-mp="2u29yzjnn7pdd" />

        <div className="mt-10 grid items-start gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-121" data-mp="22cos8pii34kd">
          <figure className="overflow-hidden rounded-3xl bg-cream-100 ring-1 ring-navy-900/10" data-id="element-122" data-mp="26ejqfl54x1tx">
            <img src={IMAGES.author} alt="Dr. Karito, dentist and creator of the Complex Rehab Case Audit™, in her clinic" className="h-full w-full object-cover" loading="lazy" data-id="element-123" data-mp="2b61oo1frwob7" />
            <figcaption className="px-4 py-3 text-center text-[11px] font-semibold uppercase tracking-[0.1em] text-navy-700/60" data-id="element-124" data-mp="1inedpeuhqpnu">
              Dr. Karito, creator of the Complex Rehab Case Audit™
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-navy-700/85 sm:text-base" data-id="element-125" data-mp="u7u33d3dacnb">
            <p data-id="element-126" data-mp="p9acgzdtwcom">
              After years of studying, teaching and working with complex
              restorative and rehabilitation cases, Dr. Karito recognized a
              recurring challenge among dentists:
            </p>
            <p className="rounded-2xl bg-cream-100 px-5 py-4 font-display text-lg font-bold italic text-navy-900" data-id="element-127" data-mp="g79ge5ubzwoj">
              They didn’t need another lecture. They needed a repeatable way to
              review a complex case before moving forward.
            </p>
            <p data-id="element-128" data-mp="25n0n6ozgdz78">
              The amount of available information can be overwhelming. The real
              challenge is organizing that information into a process that can be
              repeated from case to case.
            </p>
            <p className="font-semibold text-navy-900" data-id="element-129" data-mp="3v3mdgkjuzlng">
              That’s why she created the Complex Rehab Case Audit™ — structured
              around six practical audit building blocks:
            </p>

            <ul className="grid grid-cols-2 gap-2" data-id="element-130" data-mp="3l7rqjd8lr4ev">
              {buildingBlocks.map((b, i) => <li key={b} className="flex items-center gap-2 rounded-xl bg-navy-900 px-3 py-3 text-[12px] font-bold uppercase leading-tight tracking-[0.04em] text-cream-50 sm:text-[13px]" data-id="element-131" data-mp="3q5tae0dur7re" data-mpi={i}>
                  <span className="font-display text-gold-400" data-id="element-132" data-mp="7rk900b37j9a">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  {b}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-col items-center gap-3 rounded-3xl border-2 border-dashed border-gold-500/50 bg-cream-50 px-5 py-6 text-center sm:flex-row sm:justify-center sm:gap-5" data-id="element-133" data-mp="2sfzn1gdjzirn">
          <span className="text-sm font-extrabold uppercase tracking-[0.1em] text-navy-700/60" data-id="element-134" data-mp="1fh66b0qkyfrd">
            Scattered information
          </span>
          <ArrowRightIcon className="h-5 w-5 shrink-0 rotate-90 text-gold-500 sm:rotate-0" aria-hidden="true" data-id="element-135" data-mp="1ok7b8y3pm0tg" />
          <span className="text-sm font-extrabold uppercase tracking-[0.1em] text-navy-900" data-id="element-136" data-mp="1kilu30k570dg">
            Structured case review
          </span>
        </div>

        <div className="mt-10" data-id="element-137" data-mp="rty9l777wf0y">
          <CTAButton label="Get the audit system" subLabel="Instant access · Lifetime reference" data-id="element-138" data-mp="ruznrkjj5hmw" />
        </div>
      </div>
    </section>;
}